import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Dropdown,
  Button,
  Row,
  Col,
  Modal,
  Form,
} from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import { FiEye, FiEdit, FiTrash2 } from "react-icons/fi";
import styles from "./sections.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getServiceSlice } from "../../../../store/slices/serviceSlice";
import {
  addOrUpdateReport,
  getPatientIdSlice,
  deleteReportSlice,
} from "../../../../store/slices/patientSlice";
import Select from "react-select";
import {
  generateLinkToken,
  initiateLinking,
} from "../../../../store/slices/shareAbhaDataSlice";
import { BsCheckCircle } from "react-icons/bs";
import CreatableSelect from "react-select/creatable";
import { getMedicineSlice } from "../../../../store/slices/medicineMasterSlice";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";

const PrescriptionSection = ({ patientId, patientData }) => {
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { loading } = useSelector((state) => state.patient);
  const { token } = useSelector((state) => state.auth);
  const { services } = useSelector((state) => state.service);
  const { medicine } = useSelector((state) => state.medicineMaster);
  const { physician } = useSelector((state) => state.physician);

  const [fileError, setFileError] = useState("");
  const [showError, setShowError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState("create");
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [serviceError, setServiceError] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [reportToDelete, setReportToDelete] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [selectedReports, setSelectedReports] = useState([]);
  const [showInvalidTokenModal, setShowInvalidTokenModal] = useState(false);
  const [isSharing, setIsSharing] = useState(false);
  const [isFinalSharing, setIsFinalSharing] = useState(false);
  const [showLinkedSuccessModal, setShowLinkedSuccessModal] = useState(false);
  const [showLinkedErrorModal, setShowLinkedErrorModal] = useState(false);
  const [doctorErrorMsg, setDoctorErrorMsg] = useState("");
  const [medicineErrMsg, setMedicineErrMsg] = useState("");
  const [medicineInstructionErrMsg, setMedicineInstructionErrMsg] = useState(
    [],
  );
  const clinicId =clinicInfo?.[0]?.clinicId ||null;

  const doctorOptions = (physician || []).map((doc) => ({
    label: doc?.userId?.name,
    value: doc?._id,
  }));
  const getDoctorNameById = (doctorId) => {
    if (!doctorId) return "-";

    const doc = physician?.find((p) => String(p._id) === String(doctorId));

    return doc?.userId?.name || "-";
  };

  const medicineOptions = (medicine || [])?.map((m) => {
    const name = m.genericName?.trim() || m.brandName?.trim();
    return {
      label: name,
      value: name,
    };
  });

  const INSTRUCTIONS = [
    { label: "Once daily , Before food", value: "Once daily , Before food" },
    { label: "Once daily , After food", value: "Once daily , After food" },
    { label: "Once daily , At bedtime", value: "Once daily , At bedtime" },
    { label: "Twice daily , Before food", value: "Twice daily , Before food" },
    { label: "Twice daily , After food", value: "Twice daily , After food" },
    { label: "Morning & Evening", value: "Morning & Evening" },
    { label: "Thrice daily , After food", value: "Thrice daily , After food" },
    {
      label: "Morning, Afternoon & Night",
      value: "Morning, Afternoon & Night",
    },
    { label: "Once weekly", value: "Once weekly" },
    { label: "Alternate days", value: "Alternate days" },
    { label: "As needed (SOS)", value: "As needed (SOS)" },
    { label: "When required for pain", value: "When required for pain" },
    { label: "When fever > 100°F", value: "When fever > 100°F" },
    { label: "Before breakfast", value: "Before breakfast" },
    { label: "After meals", value: "After meals" },
    { label: "Empty stomach", value: "Empty stomach" },
    { label: "For 3 days", value: "For 3 days" },
    { label: "For 5 days", value: "For 5 days" },
    { label: "For 7 days", value: "For 7 days" },
    { label: "Continue till advised", value: "Continue till advised" },
    {
      label: "Custom , As per doctor's advice",
      value: "Custom , As per doctor's advice",
    },
  ];

  const [medicineInput, setMedicineInput] = useState(null);

  const initialState = {
    _id: "",
    service: "",
    consultationDate: "",
    reportType: "Prescription",
    patient_report: [],
    doctor: "",
    medicines: [],
  };
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    dispatch(getServiceSlice({ token }));
    dispatch(getMedicineSlice({ token }));
    dispatch(getAllPhysician({ token }));
  }, [dispatch, token]);

  useEffect(() => {
    if (physician) {
      console.log("Physician data:", physician);
    }
  }, [physician]);

  const handleAddClick = () => {
    setFormData(initialState);
    setFiles([]);
    setFileError("");
    setServiceError("");
    setModalAction("create");
    setShowModal(true);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleEditClick = (report) => {
    setFileError("");
    setServiceError("");
    setFormData({
      _id: report._id,
      service: report.service?._id || report.service,
      consultationDate: report.consultationDate?.split("T")[0],
      reportType: report.reportType,
      patient_report: Array.isArray(report.patient_report)
        ? report.patient_report
        : [report.patient_report],
      doctor: report.doctor || "",
      medicines: report.medicines || [],
    });
    setFiles([]);
    setModalAction("edit");
    setShowModal(true);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleModalClose = () => {
    setShowModal(false);
    setFormData(initialState);
    setFiles([]);
    setFileError("");
    setServiceError("");
    setModalAction("create");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const prescriptionReports =
    patientData?.reportDetails?.filter(
      (r) =>
        r.reportType === "Prescription" &&
        String(r.clinicId) === String(clinicId),
    ) || [];

  const handleFileChange = (e) => {
    setFileError("");
    setShowError("");

    const selectedFiles = Array.from(e.target.files);
    if (selectedFiles.length === 0) return;

    const validFiles = selectedFiles?.filter(
      (file) => file.size <= 1024 * 1024,
    );
    const oversizedFiles = selectedFiles?.filter(
      (file) => file.size > 1024 * 1024,
    );

    if (oversizedFiles?.length > 0) {
      setFileError("Each file must be less than or equal to 1MB.");
    }

    if (validFiles?.length === 0) {
      fileInputRef.current.value = "";
      return;
    }

    const newIsAllImages = validFiles.every((f) => f.type.startsWith("image/"));
    const newIsAllPDFs = validFiles.every((f) => f.type === "application/pdf");

    const currentIsAllImages = files.every((f) => f.type.startsWith("image/"));
    const currentIsAllPDFs = files.every((f) => f.type === "application/pdf");

    const newType = newIsAllImages ? "image" : newIsAllPDFs ? "pdf" : null;
    const currentType = currentIsAllImages
      ? "image"
      : currentIsAllPDFs
        ? "pdf"
        : null;
    if (!newType) {
      setFileError("Please select only images OR only PDFs, not both.");
      fileInputRef.current.value = "";
      return;
    }
    if (files.length > 0 && newType !== currentType) {
      setFileError(
        "You can only select one type of file. Mixing formats is not allowed.",
      );
      fileInputRef.current.value = "";
      return;
    }
    setFiles((prev) => [...prev, ...validFiles]);
    fileInputRef.current.value = "";
  };

  const convertJpgToPng = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event) {
        const img = new Image();
        img.onload = function () {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          canvas.toBlob(
            (blob) => {
              if (!blob) return reject("PNG conversion failed");
              const pngFile = new File(
                [blob],
                file.name.replace(/\.(jpg|jpeg)$/i, ".png"),
                {
                  type: "image/png",
                },
              );
              resolve(pngFile);
            },
            "image/png",
            1.0,
          );
        };
        img.src = event.target.result;
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.service) {
      setServiceError("Please select a service before submitting.");
      return;
    }
    if (!formData.doctor) {
      setDoctorErrorMsg("Please select a doctor.");
      return;
    }

    if (!formData.medicines || formData.medicines.length === 0) {
      setMedicineErrMsg("Add at least one medicine.");
      return;
    }
    const instructionErrors = [];

    formData.medicines.forEach((med, index) => {
      if (!med.instruction) {
        instructionErrors[index] = "Instruction is required";
      }
    });

    if (instructionErrors.length > 0) {
      setMedicineInstructionErrMsg(instructionErrors);
      return;
    }
    if (modalAction !== "edit" && files.length === 0) {
      setShowError("Select any prescription");
      return;
    }
    const reportData = {
      _id: formData._id,
      service: formData.service,
      consultationDate: formData.consultationDate,
      reportType: formData.reportType,
      patient_report: formData.patient_report,
      doctor: formData.doctor,
      medicines: formData.medicines,
    };
    const formDataToSend = new FormData();
    formDataToSend.append("patientId", patientId);
    formDataToSend.append("clinicId", clinicId);
    formDataToSend.append("report", JSON.stringify(reportData));

    const convertedFiles = await Promise.all(
      files.map(async (file) => {
        if (/\.(jpe?g)$/i.test(file.name)) {
          return await convertJpgToPng(file);
        }
        return file;
      }),
    );
    convertedFiles.forEach((file) => formDataToSend.append("file", file));
    await dispatch(addOrUpdateReport({ formDataToSend, token }));
    dispatch(getPatientIdSlice({ token, patientId }));
    handleModalClose();
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleDownload = (fileUrl) => {
    if (!fileUrl) return;

    const fileName = fileUrl
      .substring(fileUrl.lastIndexOf("/") + 1)
      .split("?")[0];

    fetch(fileUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => {
        console.error("Download failed", err);
      });
  };

  const handleDeleteReport = async (reportId) => {
    try {
      await dispatch(
        deleteReportSlice({
          patientId,
          reportId,
          token,
        }),
      ).unwrap();

      dispatch(getPatientIdSlice({ token, patientId }));
    } catch (err) {
      console.error("Failed to delete report:", err);
    }
  };

  const handleShareClick = async () => {
    try {
      setIsSharing(true);

      const res = await dispatch(
        generateLinkToken({
          clinicId,
          userId: patientData?.userId?._id,
          token,
        }),
      );

      setIsSharing(false);

      if (res?.payload?.success) {
        setSelectedReports([]);
        setShowShareModal(true);
      } else {
        setShowInvalidTokenModal(true);
      }
    } catch (err) {
      console.error("Error generating link token:", err);
      setIsSharing(false);
      setShowInvalidTokenModal(true);
    }
  };

  const handleCheckboxChange = (id, disabled) => {
    if (disabled) return;

    setSelectedReports((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    const selectable = prescriptionReports
      ?.filter((item) => item.status === "Unshared")
      ?.map((item) => item._id);

    const allSelected = selectable.every((id) => selectedReports.includes(id));

    if (allSelected) {
      setSelectedReports([]);
    } else {
      setSelectedReports([...new Set([...selectedReports, ...selectable])]);
    }
  };

  const handleCloseModal = () => {
    setShowInvalidTokenModal(false);
  };

  const handleFinalShare = async () => {
    const reportsToShare = selectedReports
      ?.map((id) => prescriptionReports.find((item) => item._id === id))
      ?.filter((item) => item?.status !== "Shared");
    if (reportsToShare.length === 0) return;
    const careContextData = reportsToShare?.map((r) => ({
      referenceNumber: `PR-${r._id}`,
      display: `Prescription for ${patientData?.name || "Patient"} - ${
        r.service?.serviceName || "Service"
      } - ${
        r.consultationDate
          ? new Date(r.consultationDate).toLocaleDateString("en-GB")
          : "-"
      }`,
    }));

    const body = {
      patientId,
      hiTypes: "Prescription",
      clinicId,
      careContextData,
    };

    try {
      setIsFinalSharing(true);
      const res = await dispatch(initiateLinking({ ...body, token })).unwrap();
      if (res?.success) {
        await new Promise((resolve) => setTimeout(resolve, 500));
        await dispatch(getPatientIdSlice({ token, patientId }));
        setShowLinkedSuccessModal(true);
      } else {
        setShowLinkedErrorModal(true);
      }
    } catch (err) {
      console.error("Error sharing reports:", err);
      setShowLinkedErrorModal(true);
    } finally {
      setIsFinalSharing(false);
      setShowShareModal(false);
      setSelectedReports([]);
    }
  };

  return (
    <div className={styles.invoiceWrapper}>
      <Row className="mb-3 align-items-center">
        <Col>
          <Button variant="primary" size="sm" onClick={handleAddClick}>
            Add
          </Button>
        </Col>
        <Col className="text-end">
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleShareClick}
            disabled={isSharing}
          >
            {isSharing ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                loading...
              </>
            ) : (
              "Link to ABHA"
            )}
          </Button>
        </Col>
      </Row>

      <Table bordered hover size="sm" className={styles.invoiceTable}>
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Consultation Date</th>
            <th>Doctor</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {prescriptionReports?.length > 0 ? (
            prescriptionReports?.map((item, index) => (
              <tr key={item._id || index}>
                <td>{index + 1}</td>
                <td>
                  {item.consultationDate
                    ? new Date(item.consultationDate).toLocaleDateString(
                        "en-GB",
                      )
                    : "-"}
                </td>

                <td>{getDoctorNameById(item.doctor)}</td>

                <td>
                  <span
                    className={`${styles.statusBadge} ${
                      item.status === "Shared"
                        ? styles.Shared
                        : item.status === "Transferred"
                          ? styles.Transferred
                          : styles.Unshared
                    }`}
                  >
                    {item.status === "Shared"
                      ? "Linked"
                      : item.status === "Transferred"
                        ? "Transferred"
                        : "Not Linked"}
                  </span>
                </td>
                <td>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="light"
                      size="sm"
                      className={styles.actionToggle}
                    >
                      <BsThreeDots />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={styles.dropdownMenu}>
                      <Dropdown.Item
                        className={styles.dropdownItem}
                        onClick={() => handleView(item)}
                      >
                        <FiEye className="me-2" />
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        className={styles.dropdownItem}
                        onClick={() => handleEditClick(item)}
                      >
                        <FiEdit className="me-2" />
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        className={styles.dropdownItem}
                        onClick={() => {
                          setReportToDelete(item._id);
                          setShowConfirmModal(true);
                        }}
                      >
                        <FiTrash2 className="me-2" />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                No prescription data available.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Add & Update Modal */}
      <Modal show={showModal} onHide={handleModalClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {modalAction === "edit" ? "Edit Prescription" : "Add Prescription"}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Service</Form.Label>
              <Select
                options={services?.map((s) => ({
                  label: s.serviceName,
                  value: s._id,
                }))}
                value={
                  services
                    ?.map((s) => ({ label: s.serviceName, value: s._id }))
                    .find((opt) => opt.value === formData.service) || null
                }
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    service: selected?.value ?? "",
                  }));
                  if (selected?.value) setServiceError("");
                }}
                placeholder="Select Service"
                isClearable
              />
              {serviceError && (
                <div className="text-danger mt-1">{serviceError}</div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Consultation Date</Form.Label>
              <Form.Control
                type="date"
                value={formData.consultationDate}
                max={new Date().toISOString().split("T")[0]}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    consultationDate: e.target.value,
                  }))
                }
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Doctor</Form.Label>

              <Select
                options={doctorOptions}
                value={
                  doctorOptions.find((opt) => opt.value === formData.doctor) ||
                  null
                }
                onChange={(selected) => {
                  setFormData((prev) => ({
                    ...prev,
                    doctor: selected?.value ?? "",
                  }));
                  if (selected?.value) setDoctorErrorMsg("");
                }}
                placeholder="Select Doctor"
                isClearable
              />

              {doctorErrorMsg && (
                <div className="text-danger mt-1">{doctorErrorMsg}</div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Add Medicine</Form.Label>
              <CreatableSelect
                options={medicineOptions}
                value={medicineInput}
                onChange={(selected) => {
                  setMedicineErrMsg("");
                  if (!selected) return;

                  setFormData((prev) => ({
                    ...prev,
                    medicines: [
                      ...prev.medicines,
                      {
                        name: selected.value || selected.label,
                        instruction: "",
                      },
                    ],
                  }));

                  setMedicineInput(null); 
                }}
                onCreateOption={(inputValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    medicines: [
                      ...prev.medicines,
                      { name: inputValue, instruction: "" },
                    ],
                  }));
                }}
                placeholder="Select or type medicine"
                isClearable
                isSearchable
              />
              {medicineErrMsg && (
                <div className="text-danger mt-1">{medicineErrMsg}</div>
              )}
            </Form.Group>

            <Row className="g-3 mb-3">
              {formData.medicines.map((med, index) => (
                <Col md={6} key={`${med.name}-${index}`}>
                  <div className="border rounded p-3 mb-3 bg-light h-100">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <strong style={{ color: "#0b6c92", fontWeight: 600 }}>
                        {med.name}
                      </strong>

                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => {
                          setFormData((prev) => ({
                            ...prev,
                            medicines: prev.medicines.filter(
                              (_, i) => i !== index,
                            ),
                          }));

                          setMedicineInstructionErrMsg((prev) =>
                            prev.filter((_, i) => i !== index),
                          );
                        }}
                      >
                        Remove
                      </Button>
                    </div>

                    <CreatableSelect
                      options={INSTRUCTIONS}
                      placeholder="Select or type instruction"
                      value={
                        med.instruction
                          ? { label: med.instruction, value: med.instruction }
                          : null
                      }
                      onChange={(selected) => {
                        setFormData((prev) => {
                          const updated = [...prev.medicines];
                          updated[index] = {
                            ...updated[index],
                            instruction: selected?.value || "",
                          };
                          return { ...prev, medicines: updated };
                        });

                        setMedicineInstructionErrMsg((prev) => {
                          const updated = [...prev];
                          updated[index] = "";
                          return updated;
                        });
                      }}
                      onCreateOption={(inputValue) => {
                        setFormData((prev) => {
                          const updated = [...prev.medicines];
                          updated[index] = {
                            ...updated[index],
                            instruction: inputValue,
                          };
                          return { ...prev, medicines: updated };
                        });

                        setMedicineInstructionErrMsg((prev) => {
                          const updated = [...prev];
                          updated[index] = "";
                          return updated;
                        });
                      }}
                      isClearable
                      isSearchable
                    />

                    {medicineInstructionErrMsg?.[index] && (
                      <div className="text-danger mt-1">
                        {medicineInstructionErrMsg[index]}
                      </div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Upload Prescription (PDF/Image)</Form.Label>
              <Form.Control
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                multiple
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              {fileError && (
                <div className="text-secondary mt-1">{fileError}</div>
              )}
              {showError && <div className="text-danger mt-1">{showError}</div>}

              {/* Existing Files */}
              {formData.patient_report?.map((url, index) => (
                <div key={index} className={styles.previewBox}>
                  <button
                    type="button"
                    className={`btn-close ${styles.closeBtn}`}
                    onClick={() => {
                      const updated = formData.patient_report.filter(
                        (_, i) => i !== index,
                      );
                      setFormData((prev) => ({
                        ...prev,
                        patient_report: updated,
                      }));
                    }}
                  ></button>

                  <div className={styles.previewWrapper}>
                    {url.endsWith(".pdf") ? (
                      <embed src={url} width="100%" height="100%" />
                    ) : (
                      <img
                        src={url}
                        className="img-fluid w-100 h-100"
                        alt="Prescription preview"
                      />
                    )}
                  </div>
                </div>
              ))}

              {/* New Previews */}
              {files?.map((file, idx) => (
                <div key={idx} className={styles.previewBox}>
                  <button
                    type="button"
                    className={`btn-close ${styles.closeBtn}`}
                    onClick={() =>
                      setFiles((prev) => prev.filter((_, i) => i !== idx))
                    }
                  ></button>

                  <div className={styles.previewWrapper}>
                    {file.type.startsWith("image/") ? (
                      <img
                        src={URL.createObjectURL(file)}
                        className="img-fluid w-100 h-100"
                        alt="Patient prescription preview"
                      />
                    ) : (
                      <embed
                        src={URL.createObjectURL(file)}
                        width="100%"
                        height="100%"
                      />
                    )}
                  </div>
                </div>
              ))}
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading
                ? "Submitting..."
                : modalAction === "edit"
                  ? "Update"
                  : "Submit"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* View Modal */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Prescription Files</Modal.Title>
        </Modal.Header>

        <Modal.Body className={`px-4 ${styles.modalBody}`}>
          {selectedItem?.patient_report?.length > 0 ? (
            selectedItem.patient_report?.map((fileUrl, index) => {
              const isImage = /\.(jpeg|jpg|png)$/i.test(fileUrl);
              const isPdf = /\.pdf$/i.test(fileUrl);

              return (
                <div key={index} className={styles.reportContainer}>
                  {isImage && (
                    <>
                      <img
                        src={fileUrl}
                        alt={`Prescription ${index + 1}`}
                        className={styles.reportImage}
                      />

                      <div className={styles.downloadWrapper}>
                        <Button onClick={() => handleDownload(fileUrl)}>
                          Download
                        </Button>
                      </div>
                    </>
                  )}

                  {isPdf && (
                    <iframe
                      src={fileUrl}
                      title={`Prescription PDF ${index + 1}`}
                      className={styles.reportPdf}
                    ></iframe>
                  )}
                </div>
              );
            })
          ) : (
            <p>No prescription files found.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirm Delete Modal */}
      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this report?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              handleDeleteReport(reportToDelete);
              setShowConfirmModal(false);
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Share Modal */}
      <Modal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className={styles.shareModalHeader}>
          <Modal.Title>Link Prescriptions</Modal.Title>
        </Modal.Header>

        <Modal.Body className={styles.shareModalBody}>
          {prescriptionReports?.length > 0 ? (
            <Table
              bordered
              hover
              responsive
              size="sm"
              className={`align-middle text-center ${styles.shareTable}`}
            >
              <thead>
                <tr>
                  <th>
                    <Form.Check
                      type="checkbox"
                      id="selectAll"
                      onChange={handleSelectAll}
                      checked={prescriptionReports
                        ?.filter(
                          (item) =>
                            !["Shared", "Transferred"].includes(item.status),
                        )
                        .every((item) => selectedReports.includes(item._id))}
                    />
                  </th>
                  <th>Consultation Date</th>
                  <th>Service</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {prescriptionReports?.map((item) => {
                  const isSelected = selectedReports?.includes(item?._id);
                  const nonSelectableStatuses = ["Shared", "Transferred"];
                  const isDisabled = nonSelectableStatuses.includes(
                    item?.status,
                  );

                  const rowClass =
                    item.status === "Shared" || item.status === "Transferred"
                      ? styles.shared
                      : isSelected
                        ? styles.selected
                        : "";

                  let badgeColor = "";
                  if (item.status === "Shared")
                    badgeColor = "neon-green"; 
                  else if (item.status === "Transferred")
                    badgeColor = "green";
                  else badgeColor = "skyblue";

                  return (
                    <tr key={item?._id} className={rowClass}>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={isSelected || isDisabled}
                          disabled={isDisabled}
                          onChange={() =>
                            handleCheckboxChange(item?._id, isDisabled)
                          }
                        />
                      </td>
                      <td>
                        {item?.consultationDate
                          ? new Date(item?.consultationDate).toLocaleDateString(
                              "en-GB",
                            )
                          : "-"}
                      </td>
                      <td>{item?.service?.serviceName || "N/A"}</td>
                      <td>
                        <span
                          className="badge px-3 py-2"
                          style={{
                            backgroundColor:
                              badgeColor === "neon-green"
                                ? "#12d6ac"
                                : badgeColor === "green"
                                  ? "#28a745"
                                  : "#3898cc",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                        >
                          {item.status === "Shared"
                            ? "Linked"
                            : item.status === "Transferred"
                              ? "Transferred"
                              : "Not Linked"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <p className="text-muted">No prescriptions available.</p>
          )}
        </Modal.Body>

        <Modal.Footer className={styles.shareModalFooter}>
          <Button
            variant="outline-secondary"
            onClick={() => setShowShareModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={
              !selectedReports.some((id) => {
                const item = prescriptionReports?.find((r) => r._id === id);
                return item && !["Shared", "Transferred"].includes(item.status);
              }) || isFinalSharing
            }
            onClick={handleFinalShare}
          >
            {isFinalSharing ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Linking...
              </>
            ) : (
              "Link"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Invalid Token Modal */}
      <Modal
        show={showInvalidTokenModal}
        onHide={handleCloseModal}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-semibold text-primary">Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-0 text-muted">
            Unable to generate a link Token at the moment.
            <br />
            Please try again later.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-center">
          <Button variant="primary" onClick={handleCloseModal}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Linked Success & Error Modals */}
      <Modal
        show={showLinkedSuccessModal}
        onHide={() => setShowLinkedSuccessModal(false)}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-success d-flex align-items-center">
            <BsCheckCircle className="me-2" size={24} />
            Linked Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-0" style={{ fontSize: "1rem", lineHeight: "1.5" }}>
            Your health data has been successfully linked with the ABHA address.
            <br />
            You can now access and manage it seamlessly in your ABHA account.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-center">
          <Button
            variant="success"
            onClick={() => setShowLinkedSuccessModal(false)}
            style={{ minWidth: "100px" }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showLinkedErrorModal}
        onHide={() => setShowLinkedErrorModal(false)}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-0">Something went wrong! Please try again later.</p>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-center">
          <Button
            variant="primary"
            onClick={() => setShowLinkedErrorModal(false)}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PrescriptionSection;
